import AssetHistory from './AssetHistory'

export default AssetHistory
